import React, { useEffect, useState } from 'react';
import { getRandomImage, getUserCoursesMetaData } from '../../hooks';
import { useTranslation } from 'react-i18next';
import './PathwayItemComponent.css';

export const PathwayItemComponent = ({
  data,
  index,
  handleRemoveItemClick,
  enableOptions = true,
}) => {
  const { t } = useTranslation('library');
  const [optionsVisible, setOptionsVisible] = useState(false);
  const url = `/courses/${data?.course_id || data?._source?.course_id}`;
  const [imageUrl, setImageUrl] = useState('');
  const courseId = data?.course_id || data?._source?.course_id;

  const handleImageError = (e) => {
    e.target.src = getRandomImage();
  };

  useEffect(() => {
    const fetchCourseMetaData = async () => {
      try {
        const metaData = await getUserCoursesMetaData(courseId);
        const courseImage = metaData?.course_image_asset_path;
        const fullImageUrl = courseImage
          ? `${process.env.REACT_APP_IBL_LMS_URL}${courseImage}`
          : getRandomImage();
        setImageUrl(fullImageUrl);
      } catch (error) {
        setImageUrl(getRandomImage());
      }
    };

    fetchCourseMetaData();
  }, [courseId]);

  const toggleOptions = (event) => {
    event.stopPropagation();
    setOptionsVisible(!optionsVisible);
  };

  const hideOptions = () => {
    setOptionsVisible(false);
  };

  return (
    <div className="units_block mgt30">
      <div className="unit_num">
        <div className="number">
          <div className="l_bel"></div>
          <div className="div-block-72">
            <div className="div-block-70">
              <img
                alt=""
                className="image-46"
                loading="lazy"
                src="/images/62a334c5a2b21b82f0ac43fc_hexagon_162a334c5a2b21b82f0ac43fc_hexagon.png"
              />
              <div className="num reg">{index + 1}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="unit_listing path">
        <div className="course-rec-3-wide">
          <a className="course_link_wide w-inline-block">
            <div className="course-header-rec-3-wide">
              <img
                alt=""
                className="image-34-wide"
                height={30}
                onError={handleImageError}
                src={imageUrl}
              />
              <div className="unit_type_div w-clearfix">
                <img
                  alt=""
                  className="type_img"
                  loading="lazy"
                  src="/images/play-button_2play-button.png"
                />
                <div className="text-block-52">{t('Course')}</div>
              </div>
            </div>
            <div className="course-body-4-wide">
              <div className="unit-wide-header-holder">
                <a href={url} style={{ textDecoration: 'none' }}>
                  <div className="text-block-39 wide">
                    {data?._source?.name || data?.name}
                    <br />
                  </div>
                </a>

                <div className="div-block-23 p">
                  <div className="div-block-24">
                    <img
                      alt=""
                      className="image-18"
                      loading="lazy"
                      sizes="100vw"
                      src="images/google.png"
                      srcSet="images/google-p-500.png 500w, images/google.png 512w"
                    />
                  </div>
                  <div className="text-block-16 p">Google</div>
                </div>
                <div className="unit-wide-description"></div>
              </div>
              <div className="line4 n t"></div>
              <div className="course-features">
                <div className="div-block-74 first_row wide">
                  <div className="div-block-73 wide mg-lauto">
                    <div
                      className="faq-wrap-3 c-trigger"
                      onClick={toggleOptions}
                    >
                      <img
                        src="/images/menu_1menu.png"
                        alt=""
                        className="img-trg-4"
                      />
                    </div>
                    {optionsVisible && enableOptions && (
                      <div
                        className="options_div cr-pathway active"
                        onBlur={hideOptions}
                      >
                        <div
                          className="text-block-103 remove_item"
                          style={{ backgroundColor: '#528ac1' }}
                          onClick={handleRemoveItemClick}
                        >
                          {t('Remove')}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
